<template>
	<div>
		   <div class="chat-container">
		        <div class="chat-content"    >
		          <div class="chat-message" v-for="message in messages" :key="message.id">
					 
		          <div class="chat-avatar" v-if="message.type=='1'">
		            <img :src="message.avatar" alt="avatar" />
		          </div>
		            <div class="chat-bubble" v-if="message.type=='1'" >
		              <p class="chat-text">{{ message.text }}</p>
		              <p class="chat-time">{{ message.time }}</p>
		            </div>
					
					
					
					  <div class="chat-bubble" v-if="message.type=='0'" >
					    <p class="chat-text">{{ message.text }}</p>
					    <p class="chat-time">{{ message.time }}</p>
					  </div>
								<br>		
			<div class="chat-avatar" v-if="message.type=='0'" >
			  <img :src="message.avatar" alt="avatar" />
			</div>
		          </div>
				  
				  
		        </div>
		        <div class="chat-input"  v-loading="loading"
    element-loading-text="正在等待ai回答">
		          <el-input v-model="inputValue" placeholder="请输入消息内容" @keyup.enter.native="sendMessage" clearable>
		            <el-button slot="append" icon="el-icon-position" @click="sendMessage" :disabled="dis"></el-button>
		          </el-input>
		        </div>
		      </div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      showDialog: false,
	  dis:false,
	  loading:false,
      messages: [
    
        // ... 其他对话信息
      ],
      inputValue: '',
	  userInfo:{},
	  robotHeadUrl:"https://img0.baidu.com/it/u=749682788,3836909906&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500"
    };
  },
  mounted() {
  	let info=localStorage.getItem("userInfo")
	this.userInfo=JSON.parse(info)
  },
  methods: {
    sendMessage() {
      if (!this.inputValue) {
        return;
      }
      const newMessage = {
        id: this.messages.length + 1,
        avatar: this.userInfo.headUrl,
        text: this.inputValue,
        time: new Date().toLocaleString(),
		type:'0'
      };
      this.messages.push(newMessage);
	  this.dis=true
	   this.loading=true
	this.$api.chatGpt({text:newMessage.text}).then(res=>{
		console.log(res)
		const robotMsg = {
		  id: this.messages.length+1,
		  avatar: this.robotHeadUrl,
		  text: res.data.data.data.result[0],
		  time: new Date().toLocaleString(),
				type:'1'
		};
		      this.messages.push(robotMsg);
			   this.dis=false
			    this.loading=false
	
	setTimeout(function(){
			  window.scrollTo(0, document.documentElement.scrollHeight || document.body.scrollHeight);
	},100)
	})
      this.inputValue = '';
	setTimeout(function(){
			  window.scrollTo(0, document.documentElement.scrollHeight || document.body.scrollHeight);
	},100)
    },
  },
};
</script>

<style>
	.chat-container {
	  display: flex;
	  flex-direction: column;
	  margin: auto;
	  padding: 20px;
	  width: 60%;
	}
	.chat-content {
	  flex: 1;
	  overflow-y: auto;
	}
	.chat-message {
	  display: flex;
	  margin-bottom: 10px;

	
	}

	.chat-avatar {
	  width: 50px;
	  height: 50px;
	  margin-right: 10px;
	}
	.chat-avatar img {
	  width: 100%;
	  height: 100%;
	  border-radius: 50%;
	}
	.chat-bubble {
	  display: flex;
	  flex-direction: column;
	  justify-content: center;
	  background-color: #f5f5f5;
	  padding: 10px;
	  border-radius: 10px;
	  flex: 1;
	}
	.chat-text {
	  font-size: 14px;
	  margin-bottom: 5px;
	}
	.chat-time {
	  font-size: 12px;
	  color: #999;
	}
	.chat-input {
	  margin-top: 20px;
	  display: flex;
	  justify-content: space-between;
	}
	.el-input {
	  flex: 1;
	  margin-right: 10px;
	}
</style>